import { getToken, onMessage } from 'firebase/messaging';
import { doc, updateDoc } from 'firebase/firestore';
import { db, messaging as firebaseMessaging } from '../firebase';

const vapidKey = 'BCy4A9pJtQWGqHlW9da6Kulg1QKWma5TxG_A0bXZYzAGEnG6dnTYq9KojFvQLCgYN10yYzXdxYrPT5YxVja2X9g';

// Request notification permission and get FCM token
export async function requestNotificationPermission(userId) {
  try {
    console.log('Requesting notification permission...');
    
    // Check if notifications are supported
    if (!('Notification' in window)) {
      console.log('This browser does not support notifications');
      return null;
    }

    // Check if service worker is supported
    if (!('serviceWorker' in navigator)) {
      console.log('Service Worker not supported');
      return null;
    }

    // Check if messaging is available
    if (!firebaseMessaging) {
      console.log('Firebase messaging not available');
      return null;
    }

    // Request permission
    const permission = await Notification.requestPermission();
    console.log('Notification permission:', permission);
    
    if (permission === 'granted') {
      console.log('Notification permission granted, getting token...');
      
      // Wait for service worker to be ready
      const registration = await navigator.serviceWorker.ready;
      console.log('Service worker ready:', registration);
      
      // Get FCM token
      const token = await getToken(firebaseMessaging, { 
        vapidKey,
        serviceWorkerRegistration: registration 
      });
      
      if (token) {
        console.log('FCM Token obtained:', token.substring(0, 20) + '...');
        
        // Save token to Firestore
        if (userId) {
          await updateDoc(doc(db, 'users', userId), {
            fcmToken: token,
            fcmTokenUpdatedAt: new Date().toISOString()
          });
          console.log('✅ FCM token saved to Firestore');
        }
        
        return token;
      } else {
        console.log('No registration token available');
        return null;
      }
    } else {
      console.log('Notification permission denied');
      return null;
    }
  } catch (error) {
    console.error('Error getting FCM token:', error);
    console.error('Error details:', error.message);
    return null;
  }
}

// Listen for foreground messages
export function setupMessageListener(callback) {
  if (!firebaseMessaging) {
    console.error('Messaging not available');
    return () => {};
  }
  
  const unsubscribe = onMessage(firebaseMessaging, (payload) => {
    console.log('Foreground message received:', payload);
    callback(payload);
  });
  
  return unsubscribe;
}

// Show browser notification
export function showNotification(title, options = {}) {
  if ('Notification' in window && Notification.permission === 'granted') {
    new Notification(title, {
      icon: '/favicon.png',
      badge: '/favicon.png',
      ...options
    });
  }
}
